import { Fragment, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FilePageService from "../../API/FilePage/FilePageService";
import Select from "react-select";

const EditQuotationBasis = (props) => {
  const { t } = useTranslation();
  const {
    showmodal,
    handleModalClose,
    handleEditQuotationBasisModalCloseAfterAPICall,
    selectedId,
    riskTypeList,
  } = props;

  const riskTypeOptions = Object.entries(riskTypeList).map(([key, label]) => ({
    value: key,
    label: label,
  }));

  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    risk_type: "",
    cost_of_amount: "",
    percentage: "",
    percentage_of_bonus: "",
  });

  useEffect(() => {
    if (showmodal && selectedId) {
      ShowQuotationBasis(selectedId);
      setFormData({
        name: "",
        risk_type: "",
        cost_of_amount: "",
        percentage: "",
        percentage_of_bonus: "",
      });
    }
  }, [showmodal, selectedId]);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  const ShowQuotationBasis = async (id) => {
    setLoading(true);
    try {
      const response = await FilePageService.quotation_basis_show(id);

      if (response.data.status) {
        setLoading(false);
        const details = response.data.QuotationBasis;

        setFormData({
          name: details.name || "",
          risk_type: details.risk_type?.toString() || "",
          cost_of_amount: details.cost_of_amount || "",
          percentage: details.percentage || "",
          percentage_of_bonus: details.percentage_of_bonus || "",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "number" && name !== "cost_of_amount") {
      if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
        let num = Number(value);
        if (!isNaN(num)) {
          if (num < 0) num = 0;
          if (num > 100) num = 100;
          setFormData((prev) => ({
            ...prev,
            [name]: num.toString(),
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            [name]: value,
          }));
        }
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.name?.trim()) errors.name = "Le nom est requis.";
    if (!formData.risk_type) errors.risk_type = "Le type de risque est requis.";

    if (formData.risk_type == "2" && !formData.cost_of_amount) {
      errors.cost_of_amount = "Le montant est requis pour le type DO.";
    }
    return errors;
  };

  const UpdateQuotationBasis = async (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setFlashMessage({
        type: "error",
        message: t("requriedErrorMessageLabel"),
      });
      return;
    }

    setLoading(true);

    const payload = {
      name: formData.name,
      risk_type: formData.risk_type,
      percentage: formData.percentage == 0 ? null : formData.percentage,
      percentage_of_bonus: formData.percentage_of_bonus == 0 ? null : formData.percentage_of_bonus,
    };

    if (formData.risk_type == "2") {
      payload.cost_of_amount = formData.cost_of_amount || 0;
    }

    try {
      const response = await FilePageService.quotation_basis_update(
        selectedId,
        payload
      );

      if (response.data.status) {
        setFlashMessage({
          type: "success",
          message: response.data.message
            ? response.data.message
            : t("updatedSuccessfully"),
        });
        handleEditQuotationBasisModalCloseAfterAPICall();
        setFormData({
          name: "",
          risk_type: "",
          cost_of_amount: "",
          percentage: "",
          percentage_of_bonus: ""
        });
      } else {
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setFlashMessage({
        type: "error",
        message: error.response?.data?.message || t("somethingWentWrong"),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Modal
        className="missing-doc-modal invalid-doc-modal"
        show={showmodal}
        onHide={handleModalClose}
      >
        <Form onSubmit={UpdateQuotationBasis}>
          <Modal.Header closeButton>
            <Modal.Title>Modifier la base de devis</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h2>Modifier la base de devis</h2>

            {flashMessage.message && (
              <div
                className={`mt-3 mx-w-620 alert ${
                  flashMessage.type === "success"
                    ? "alert-success"
                    : "alert-danger"
                } text-center`}
                role="alert"
              >
                {flashMessage.message}
              </div>
            )}
            <div className="mt-3">
              <Form.Group className="mb-3">
                <Form.Label>
                  Nom de base de citation <span>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Nom de base de citation"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Type de risque <span>*</span>
                </Form.Label>
                <Select
                  options={riskTypeOptions}
                  value={riskTypeOptions.find(
                    (option) => option.value === formData.risk_type
                  )}
                  onChange={(selectedOption) =>
                    setFormData((prev) => ({
                      ...prev,
                      risk_type: selectedOption.value,
                    }))
                  }
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                  }}
                  placeholder={"Sélectionnez le type de risque"}
                  isSearchable={true}
                  noOptionsMessage={() => t("NorecordsfoundLabel")}
                />
              </Form.Group>

              {formData?.risk_type == "2" && (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Montant du coût <span>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="cost_of_amount"
                    value={formData.cost_of_amount}
                    onChange={handleChange}
                    placeholder="Montant du coût"
                    onWheel={(e) => e.target.blur()}
                  />
                </Form.Group>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Taux de base</Form.Label>
                <Form.Control
                  type="number"
                  name="percentage"
                  value={formData.percentage}
                  onChange={handleChange}
                  placeholder="Taux de base"
                  min={0}
                  max={100}
                  onWheel={(e) => e.target.blur()}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Taux de minoration</Form.Label>
                <Form.Control
                  type="number"
                  name="percentage_of_bonus"
                  value={formData.percentage_of_bonus}
                  onChange={handleChange}
                  placeholder="Taux de minoration"
                  min={0}
                  max={100}
                  onWheel={(e) => e.target.blur()}
                />
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancel-btn"
              variant="primary"
              onClick={handleModalClose}
            >
              {t("cancelLabel")}
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              Mise à jour
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default EditQuotationBasis;
